module.exports = __webpack_public_path__ + "img/change.85d2c7c6.svg";